import React from "react";
import {
  NavLink
} from "react-router-dom";

class Header extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props)
    this.state = {
      page_title: '影像分析平台',
      logout: (typeof localStorage.token !== 'undefined' && localStorage.token !== '') ? true : false
    };

    document.title = this.state.page_title;

  }
  render() {
    return (
      <div>
      <nav className="site-header sticky-top">
        <div className="container-fluid d-flex flex-column flex-md-row justify-content-between">
          <NavLink to="/" className="py-2 d-none d-md-inline-block">{this.props.company_name || this.state.page_title}</NavLink>
          {this.state.logout && <NavLink to="/console" className="py-2 d-none d-md-inline-block">console</NavLink>}
        </div>
      </nav>
      </div>
    );
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/apps/site/common/header.js